import { IOccupations } from '../../UI/Components/Occupations/occupations-types';

export const Occupations: IOccupations = {
    1: { FR: 'Sans emploi', KEY: 'occupation.1', EN: 'Jobless' },
    2: { FR: 'Commerçant', KEY: 'occupation.2', EN: 'Merchant' },
    3: { FR: 'Etudiant/Elève', KEY: 'occupation.3', EN: 'Student/Pupil' },
    4: { FR: 'Employé', KEY: 'occupation.4', EN: 'Employee' },
    5: { FR: 'Fonctionnaire', KEY: 'occupation.5', EN: 'Civil servant' },
    6: { FR: 'Artiste/Liberal', KEY: 'occupation.6', EN: 'Artist/Liberal' },
    7: { FR: 'Athlète', KEY: 'occupation.7', EN: 'Sport staff' },
    8: { FR: 'Personnel Religieux', KEY: 'occupation.8', EN: 'Religious staff' },
    9: { FR: 'Police/Militaire', KEY: 'occupation.9', EN: 'Police/Military' },
    10: { FR: 'Politiciens/Officials', KEY: 'occupation.10', EN: 'Politicians/Officials' },
    11: { FR: 'Personnel mine/mining staff', KEY: 'occupation.11', EN: 'Personnel minier/mining staff' },
    12: { FR: 'Avocat/Judiciaire/Notaire', KEY: 'occupation.12', EN: 'Lawyer/Judicial Staff/Notaries' },
    13: { FR: 'Médecin/Infirmier', KEY: 'occupation.13', EN: 'Doctor/Nursing Staff' },
    14: { FR: 'Agent Immobilier/Réal Estate', KEY: 'occupation.14', EN: 'Real Estate Agent' },
    15: { FR: 'Comptable/auditeur', KEY: 'occupation.15', EN: 'Accountant/auditor' },
    16: { FR: 'Parieurs/joueurs', KEY: 'occupation.16', EN: 'Betters/casino gamblers' } // fixed KEY
};

export default Occupations;
